import { empApi } from "./client";

// =============================================================
// API Quản lý chuyên cần (attendance management) - FEv1 cổng nhân viên.
// Danh sách chấm công theo ngày của nhân viên cấp dưới (role-based).
// Danh sách nhân viên cấp dưới tái dùng staffManager.api.
// =============================================================

// Danh sách chấm công theo ngày - khối kinh doanh -> { items, pagination }
export const getBusinessAttendanceListApi = (params) =>
  empApi.get("/employee/app/listAttendanceManagementBusiness", params);

// Danh sách chấm công theo ngày - khối hỗ trợ kinh doanh -> { items, pagination }
export const getSupportBusinessAttendanceListApi = (params) =>
  empApi.get("/employee/app/listAttendanceManagementSupportBusiness", params);

// Thống kê chấm công (legendCounts cho biểu đồ tròn) - khối kinh doanh
export const getBusinessAttendanceStatisticApi = (params) =>
  empApi.get("/employee/app/listAttendanceStatisticsManagementBusiness", params);

// Thống kê chấm công - khối hỗ trợ kinh doanh
export const getSupportBusinessAttendanceStatisticApi = (params) =>
  empApi.get("/employee/app/listAttendanceStatisticsManagementSupportBusiness", params);
